import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import HistoryComponent from 'src/components/elements/account/newHistoryUI/HistoryComponent';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {NavigationProp} from '@react-navigation/native';
import AccountConstants from '../../../../constants/AccountConstants';

type HistoryComponentProps = {
  histroyfilter?: AccountConstants;
  navigation: NavigationProp<HistoryComponentProps>;
};

const ReferralsHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.referral;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'ReferralsHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return <HistoryComponent histroyfilter={filterTypes.referral} {...props} />;
};

export default ReferralsHistoryList;
